import type { IDBPDatabase} from "idb";
import { openDB } from "idb";
import Lang from "./modules/lang";


const cache = new (class Cache {
    private DB_VERSION = 1;
    private DB_NAME = "cache"
    private db?: IDBPDatabase;
    
    lang?: Lang;

    async init() {
        this.db = await openDB(this.DB_NAME, this.DB_VERSION, {
            upgrade(db) {
                db.createObjectStore("lang")
            }
        });
        this.lang = new Lang(this.db);
    }


});

export default cache;